import {utils as KuUtils} from '@/kuTools/sdk/utils';
import ArrowRightSvg from '@/assets/svg/flexBuilder/arrowRight.svg?tsx';
import {openFlexBuilderInstructionDoc} from '../../utils';
import {FlexBuilderType, LogIdMap} from '../../constant';
import styles from './index.module.scss';

export const EntryTooltipContentFactory = ({
    title = '随心搭 Beta',
    flexBuilderType,
}: {
    title: string;
    flexBuilderType: FlexBuilderType;
}) => {
    const EntryTooltipContent = () => {
        const handleOpenInstruction = () => {
            openFlexBuilderInstructionDoc();

            if (flexBuilderType === FlexBuilderType.frontend) {
                KuUtils.kuLogger({
                    repId: LogIdMap.ClickGuidance,
                    params: {
                        pos: 'insert-entry',
                        type: 'guide',
                    },
                });
            }
        };

        return (
            <div className={styles.tipContainer}>
                <div className={styles.header}>
                    <span>{title}</span>
                    <div className={styles.right} onClick={handleOpenInstruction}>
                        使用说明
                        <ArrowRightSvg className={styles.icon} />
                    </div>
                </div>
                <div>快速生成你所需要的文档组件</div>
            </div>
        );
    };
    return EntryTooltipContent;
};
